import styled from "styled-components";
import { Button, InputRadio } from "discover.medical.react-component-library";

export const StyledLocationsRadio = styled(InputRadio)`
  margin: 0.625rem 0;
  display: block;
`;

export const StyledButton = styled(Button)`
  &:last-child {
    margin-left: 1rem;
  }
`;
